import { apiRoutes } from '@/../config'
import axios from 'axios'

const state = {
    status: '',
    hasLoadedOnce: false
}

const getters = {
    authStatus: state => state.status
}

const actions = {
    auth_request: async ({ commit }, user) => {
        try {
            commit('auth_request')
            const res = await axios.post(apiRoutes.auth, user)
            axios.defaults.headers.common.Authorization = 'Bearer ' + res.data.tokens.accessToken
            commit('auth_success')
            commit('user_success', res.data.credentials)
            return
        } catch (e) {
            commit('auth_error', e)
            throw e
        }
    },
    auth_refresh: async ({ commit, dispatch }) => {
        try {
            commit('auth_request')
            const res = await axios.post(apiRoutes.auth, {})
            const token = 'Bearer ' + res.data.tokens.accessToken
            axios.defaults.headers.common.Authorization = token
            commit('auth_success', token)
            commit('user_success', res.data.credentials)
            return
        } catch (e) {
            commit('auth_error', e)
            dispatch('auth_logout', e)
            throw e
        }
    },
    auth_logout: ({ commit }) => {
        return new Promise(resolve => {
            commit('auth_logout')
            commit('user_logout')
            axios.defaults.headers.common.Authorization = ''
            localStorage.removeItem('refreshToken')
            resolve()
        })
    }
}

const mutations = {
    auth_request: state => {
        state.status = 'loading'
    },
    auth_success: (state) => {
        state.status = 'success'
        state.hasLoadedOnce = true
    },
    auth_error: state => {
        state.status = 'error'
        state.hasLoadedOnce = true
    },
    auth_logout: state => {
        state.refreshToken = ''
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}